import styled from 'styled-components';
import appTheme from 'theme-config';
import type { ReactNode } from 'react';
import Logo from 'elements/Logo';

const Wrapper = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  height: '100vh',
  backgroundColor: appTheme.splash.backgroundColor,
  gap: '24px',
});

const LogoWrapper = styled.div({
  margin: '0 auto !important',
  alignSelf: 'center',
});

const FullScreenLoader = (): ReactNode => (
  <Wrapper>
    <LogoWrapper>
      <Logo size="medium" />
    </LogoWrapper>
  </Wrapper>
);

export default FullScreenLoader;
